import { ComposeViewState, ComposeControl } from 'owa-mail-compose-store';
import { findComposePlugins } from '../plugins/ComposePlugins';
import { getTotalRecipientCount } from './viewStateUtils';

export default function getAutoFocusControl(viewState: ComposeViewState): ComposeControl {
    const plugins = findComposePlugins(viewState);
    const hasCursorSnapshot = plugins && plugins.contentOperationPlugin.hasCursorSnapshot();
    if (!hasCursorSnapshot && !viewState.isInlineCompose) {
        if (viewState.subjectPickerViewState.nextFocusControl) {
            return viewState.subjectPickerViewState.nextFocusControl;
        } else if (getTotalRecipientCount(viewState) == 0) {
            return ComposeControl.RecipientWellTo;
        } else if (!viewState.subject) {
            return ComposeControl.SubjectLine;
        }
    }

    return ComposeControl.Editor;
}
